<style>
</style>
<template>
  <div
    ref="echart"
    v-resize="onResize"
    style="width: inherit; height: inherit"
  />
</template>
<script>
import * as echarts from "echarts/dist/echarts.js";
import * as ecStat from "echarts-stat/dist/ecStat.js";
echarts.registerTransform(ecStat.transform.clustering);

import { createNamespacedHelpers } from "vuex";
const orrNamespace = createNamespacedHelpers("orr");

// import options from './data/cluster';
export default {
  props: ["module", "chartId"],
  data: function () {
    return {
      chart: null,
    };
  },
  methods: {
    rendered: function () {},
    onResize: function () {
      if (this.chart) {
        this.chart.resize();
      }
    },
    ...orrNamespace.mapMutations([]),
    ...orrNamespace.mapActions(["aLoadFeatures"]),
    async display() {
      await this.aLoadFeatures();
      this.chart.setOption(this.options);
    },
  },
  computed: {
    ...orrNamespace.mapState({
      heatmapKey: (state) => state.heatmapKey,
      series: (state) => state.heatmapSeries,
      options: (state) => state.clusterOptions,
    }),
  },
  components: {},
  mounted() {
    this.chart = echarts.init(this.$refs.echart);
    this.display();
    // this.chart.setOption(options);
  },
};
</script>
